export function getHost() {
  let host = process.env.HOST;
  if (typeof window !== 'undefined') {
    host = window.location.origin;
  }
  return host;
}
